export const getCenteredPageContentClass = () => {
	return 'w-full md:pt-8 p-4 flex justify-center';
};
